// extracted by mini-css-extract-plugin
export var fadeInOut = "_2o-3";
export var icon = "_2o-4";
export var savedIndicator = "_2o-2";
export var savingIndicator = "_2o-0";
export var spin = "_2o-1";